import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function AboutAuthor() {
  return <section className="w-full bg-[#FAF8FF] py-24 px-6 border-t border-purple-50" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <div className="grid md:grid-cols-5 gap-12 items-center" data-id="element-18">
          <FadeIn className="md:col-span-2" data-id="element-19">
            <div className="aspect-[4/5] rounded-3xl bg-purple-100 overflow-hidden relative shadow-sm" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/rGUetqG1LDeW9BVdYBWvkt/12.1.png" alt="Valentina Reyes" className="absolute inset-0 w-full h-full object-cover" data-id="element-21" />
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="md:col-span-3" data-id="element-22">
            <h2 className="text-3xl md:text-4xl font-serif text-night-900 mb-6" data-id="element-23">
              ¿Quién creó este método?
            </h2>
            <div className="mb-8" data-id="element-24">
              <p className="text-xl font-bold text-night-900" data-id="element-25">
                Valentina Reyes
              </p>
              <p className="text-purple-600 font-medium" data-id="element-26">
                Especialista en bienestar mental, manejo del estrés y
                mindfulness aplicado.
              </p>
            </div>

            <div className="space-y-4 text-lg text-slate-700 leading-relaxed" data-id="element-27">
              <p data-id="element-28">
                Durante años acompañé a mujeres que llegaban a la noche
                completamente agotadas... pero incapaces de descansar de verdad.
              </p>
              <p data-id="element-29">
                Lo que descubrí es que el problema casi nunca era "el sueño."
                Era la ausencia de un sistema de cierre mental real.
              </p>
              <p data-id="element-30">
                Por eso construí Mente en Calma: no como un producto genérico,
                sino como el método que yo misma hubiera necesitado.
              </p>
              <p data-id="element-31">
                Condensé los principios más efectivos de la neurociencia del
                sueño, la regulación del sistema nervioso y el mindfulness
                práctico... en un protocolo de 7 noches que cualquier mujer
                ocupada pueda seguir.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}